// extracted by mini-css-extract-plugin
export default {"custom-tag-container":"custom-tag_custom-tag-container__+shNp","custom-tag-text":"custom-tag_custom-tag-text__Y2cpE"};